import { Action, configureStore, ThunkAction } from "@reduxjs/toolkit";
import ReportReducer from "../../pages/report/slice";
import LayoutReducer from "../../ui/layout/slice";
import KeycloakReducer from "../keycloak/slice";

export const store = configureStore({
    reducer: {
        keycloak: KeycloakReducer,
        layout: LayoutReducer,
        report: ReportReducer
    },
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware({
            serializableCheck: false,
        }),
});

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
export type AppThunk<ReturnType = void> = ThunkAction<
    ReturnType,
    RootState,
    unknown,
    Action<string>
>;
